import React from 'react';
import PropTypes from 'prop-types';
import { Anchor, Heading, Paragraph } from '@zillow/constellation';

import type { Brand } from '..';

const BlockedUserComponent = ({ brand }: { brand: Brand }): JSX.Element => {
  const email = brand === 'zillow' ? 'account_verification@zillow.com' : 'account_verification@hotpads.com';

  function getBrandText(brand: Brand): string {
    let brandText = '';

    switch (brand) {
      case 'zillow':
        brandText = 'Zillow';
        break;
      case 'trulia':
        brandText = 'Trulia';
        break;
      case 'hotpads':
        brandText = 'HotPads';
    }

    return brandText;
  }

  const brandText = getBrandText(brand);

  return (
    <div className="BlockedUserComponent">
      <Heading level="5" marginBottom="md">
        Your account is currently disabled
      </Heading>
      <Paragraph marginBottom="md">
        We are unable to access your properties at this time. Please contact{' '}
        <Anchor href={`mailto:${email}`}>{email}</Anchor> to resolve the issue.
      </Paragraph>
      <Paragraph>
        Return to <Anchor href={`https://www.${brand.toLowerCase()}.com`}>{brandText}</Anchor>
      </Paragraph>
    </div>
  );
};

const BrandValues: Array<Brand> = ['zillow', 'hotpads', 'trulia'];

BlockedUserComponent.propTypes = {
  brand: PropTypes.oneOf(BrandValues).isRequired,
};

export default BlockedUserComponent;
